import { createAsyncThunk } from '@reduxjs/toolkit';

export const onValidateSign = createAsyncThunk(
  'onValidateSign',
  async (
    data: {},
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    return {};
  }
);

export default onValidateSign;
